// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e__x","legend":"e_0x","legendContent":"e_1x","contentWrapper":"e_2x","fieldsetContent":"e_3x"};